module.exports = __webpack_public_path__ + "static/img/institution08.3c8c761.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/institution08.png
// module id = H60K
// module chunks = 1